import { CategoryLandingPageKey } from '@lambda/apis/src/category/types';
import Section from '@/components/commons/Section';
import { SEO } from '@/lib/collections/category/seo';

const Seo = ({ handle }: { handle: CategoryLandingPageKey }) => {
  const content = SEO[handle];

  if (content == null) return null;

  return (
    <div className="bg-white">
      <div className="reebelo-container">
        <Section>
          {content.map((el) => (
            <div className="mt-6 first:mt-0 sm:mt-8" key={el.title}>
              <h2 className="text-lg font-bold">{el.title}</h2>
              <div className="text-sm text-gray-700/70">
                {el.description.split('\n').map((text) => {
                  const replacedText = text.replace(
                    /Reebelo/g,
                    '<a href="/" class="underline hover:text-gray-700">Reebelo</a>',
                  );

                  return (
                    <p
                      className="mt-3 first:mt-0"
                      key={text}
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{ __html: replacedText }}
                    ></p>
                  );
                })}
              </div>
            </div>
          ))}
        </Section>
      </div>
    </div>
  );
};

export default Seo;
